import { hot } from 'react-hot-loader/root';
import Component from './user-redux';

export default hot(Component);
